import styled from 'styled-components';

export const $StepHeaderDidactic = styled.div`
  display: block;
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  margin-bottom: 1rem;
  white-space: normal;
`;
